import React, { useState, useEffect, useCallback } from 'react';
import ChatSidebar from './ChatSidebar';
import ChatWindow from './ChatWindow';
import '../css/ChatPage.css';


function ChatPage({
  callManagerRef,
  inCall,
  setInCall,
  selectedUser,
  setSelectedUser,
  activeCallType,
  setActiveCallType,

  activeCallUser,
  setActiveCallUser
}) {

  const [refreshTrigger, setRefreshTrigger] = useState(0);



  // =========================================================
  // MARK MESSAGES AS READ
  // =========================================================

  const markMessagesAsRead =
    useCallback(
      async (userId) => {

        try {

          await fetch(
            `${process.env.REACT_APP_API_URL}/api/chat/mark-as-read/${userId}`,
            {
              method: 'PUT',

              headers: {
                Authorization:
                  `Bearer ${localStorage.getItem('authToken')}`
              }
            }
          );


          setRefreshTrigger(
            prev => prev + 1
          );


          window.dispatchEvent(
            new CustomEvent(
              'refresh-notifications'
            )
          );

        } catch (err) {

          console.error(
            "❌ Failed to mark as read",
            err
          );
        }

      },
      []
    );
  // =========================================================
  // RESTORE SELECTED CHAT USER
  // =========================================================

  useEffect(() => {

    const loadSelectedUser = async () => {

      const token =
        localStorage.getItem(
          'authToken'
        );

      const params =
        new URLSearchParams(
          window.location.search
        );

      const userId =
        params.get('userId');


      // ==========================================
      // 1. USER ID FROM URL
      // /chat?userId=123
      // ==========================================

      if (userId && token) {

        try {

          const response =
            await fetch(
              `${process.env.REACT_APP_API_URL}/api/users/${userId}/details`,
              {
                headers: {
                  Authorization:
                    `Bearer ${token}`
                }
              }
            );


          if (!response.ok) {

            throw new Error(
              `User load failed: ${response.status}`
            );
          }


          const user =
            await response.json();


          setSelectedUser(user);


          localStorage.setItem(
            'selectedChatUser',
            JSON.stringify(user)
          );


          await markMessagesAsRead(
            user.id
          );


          return;

        } catch (error) {

          console.error(
            '❌ Unable to open selected chat user:',
            error
          );

        }
      }


      // ==========================================
      // 2. FALLBACK LOCAL STORAGE
      // ==========================================

      const savedUser =
        localStorage.getItem(
          'selectedChatUser'
        );


      if (savedUser) {

        try {

          const parsedUser =
            JSON.parse(savedUser);


          setSelectedUser(
            parsedUser
          );


        } catch (error) {

          console.error(
            '❌ selectedChatUser parse error:',
            error
          );

        }
      }

    };


    loadSelectedUser();

  }, [setSelectedUser, markMessagesAsRead]);

  // =========================================================
  // GIFT RETURN
  // =========================================================

  useEffect(() => {

    const params =
      new URLSearchParams(
        window.location.search
      );

    const giftId =
      params.get('giftId');

    const receiverId =
      params.get('receiverId');

    const success =
      params.get('success');

    const token =
      localStorage.getItem(
        'authToken'
      );


    if (
      success === 'true' &&
      giftId &&
      receiverId &&
      token
    ) {

      window.history.replaceState(
        {},
        document.title,
        "/chat"
      );


      fetch(
        `${process.env.REACT_APP_API_URL}/api/gifts/send`,
        {
          method: "POST",

          headers: {
            "Content-Type":
              "application/json",

            Authorization:
              `Bearer ${token}`
          },

          body: JSON.stringify({
            giftId:
              parseInt(giftId),

            receiverId:
              parseInt(receiverId)
          })
        }
      )

        .then(res =>
          res.ok
            ? res.text()
            : Promise.reject(
              "Échec"
            )
        )

        .then(() => {

          console.log(
            "✅ Cadeau enregistré"
          );


          return fetch(
            `${process.env.REACT_APP_API_URL}/api/users/${receiverId}/details`,
            {
              headers: {
                Authorization:
                  `Bearer ${token}`
              }
            }
          );
        })

        .then(res =>
          res.json()
        )

        .then(user => {

          setSelectedUser(
            user
          );
        })

        .catch(err => {

          console.error(
            "❌ Erreur d’enregistrement ou chargement du destinataire :",
            err
          );
        });
    }

  }, [setSelectedUser]);





  // =========================================================
  // SELECT CHAT USER
  // =========================================================

  const handleSelectUser = (
    user
  ) => {

    setSelectedUser(
      user
    );

    localStorage.setItem(
      'selectedChatUser',
      JSON.stringify(user)
    );

    window.history.replaceState(
      {},
      document.title,
      `/chat?userId=${user.id}`
    );

    markMessagesAsRead(
      user.id
    );
  };


  // =========================================================
  // RENDER
  // =========================================================

  return (

    <div className="chat-page">

      <ChatSidebar

        onSelectUser={
          handleSelectUser
        }

        refreshTrigger={
          refreshTrigger
        }

        selectedUser={
          selectedUser
        }

      />


      <ChatWindow

        user={
          selectedUser
        }

        callManagerRef={
          callManagerRef
        }

        inCall={
          inCall
        }

        setInCall={
          setInCall
        }
        activeCallType={activeCallType}
        setActiveCallType={setActiveCallType}

        activeCallUser={
          activeCallUser
        }

        setActiveCallUser={
          setActiveCallUser
        }
      />

    </div>
  );
}


export default ChatPage;